// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__VbAEn","employee-header-item":"Header_employee-header-item__UHzWp"};